import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  FormControl, InputLabel,
  InputAdornment,
  IconButton, styled,
  InputBase,
  Select, MenuItem,
  Autocomplete,
  TextField,
  Backdrop
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

import {
  updatePaymentMethod, paymentGenerateToken,
  paymentGenerateSignature,
  submitAutoPaymentMethod
} from "../../../../shared/hooks/useFetchPayment";

import { getAccountSummary } from "../../../../shared/hooks/useFetchAccountInfo";
import { addEneventGTM, AddUpdatePaymentGTM, errorConditionGTM, sendEventGTMLog } from "../../Utils/googleTags";
import { AMS_Lookup } from "../../../../shared/hooks/useFetchCompleteAddress";
import { paypalTokenDetails } from "../../../../shared/hooks/useFetchPaypal";
import ApiUrls from "../../Utils/axr";
import { useAppSelector, useAppDispatch } from "../../hooks";
import {
  getlistOfPaymentMethods,
  onAddEditPaymentMethodLoadingStart,
  onAddEditPaymentMethodLoadingStop,
  setaddPaymentMethodError,
  setShowEditPaymentPopUp,
} from "../../SharedContextStore/slices/paymentMethods";

import StateList from "../../Utils/USA-StateList.json";
import VisibilityIcon from "../../assets/icon-view-on.png";
import VisibilityOffIcon from "../../assets/icon-view-off.png";
import payPalIcon from "../../assets/payments-logo-pay-pal.webp";
import close from "../../assets/icon-close.svg";
import {
  validateCreditCardNumberAllowed,
  getCardTypeByCardNumber, validateExpirationDate
} from "../../Utils/validations-utils";
import {
  creditCardExpiryAutoFormat,
  debounce,
  encryptNativeSpeedPay,
  getCardNumberWithMasking,
} from "../../Utils/utils";

import "./index.css";
import ToastCustonIcon from "../../SharedComponents/toastCustomIcons";

import {
  EC_DW_LOGGING_STEPS,
  publicKeySpeedPay,
} from "../../../../shared/utils/Constants";
import { getAMSToken } from "../../SharedContextStore/slices/amsToken";
import useBrightspeedHeaders from "../../hooks/useBrightspeedHeader";

/* Add card icon Images */
import discovercard from "../../assets/images/paymentInfo/discover_ico.png";
import mastercard from "../../assets/images/paymentInfo/mastercard_ico.svg";
import visacard from "../../assets/images/paymentInfo/visacard_ico.svg";
// import discovercard from "../../assets/images/paymentInfo/discovercard.svg";
//  import mastercard from "../../assets/images/paymentInfo/mastercard.svg";
// import visacard from "../../assets/images/paymentInfo/visacard.svg";

import discovercarddisabled from "../../assets/images/paymentInfo/discovercarddisabled.svg";
import mastercarddisabled from "../../assets/images/paymentInfo/mastercarddisabled.svg";
import visacarddisabled from "../../assets/images/paymentInfo/visacarddisabled.svg";
import { getquickBillPayPageContent } from "../../SharedContextStore/slices/contents/qbpContentAem";
import DwLogutil from "../../Utils/DwLogutil";
import { QuickBillPay } from "../../SharedComponents/contents";
import useBrightspeedUser from "../../hooks/useUser";
import { sendEventLog } from "../../Utils/app-log";

interface addpaymentMethodNew {
  onClose: () => void;
  onAddEditSuccess: () => void;
  fromEditCard?: boolean;
  card?: {
    fullName: string;
    creditCardNumber: string;
    expiryDate: string;
    cvv: string;
    isPrimaryPaymentMethod: boolean;
    address1: string;
    //address2: string;
    city: string;
    zipCode: string;
    state: string;
    cardId: string | null;
    isTermsAndCondition: boolean;
    creditCardType: string;
    paymentMethodKind: string;
  };
  showApifailPopup: () => void;
  QBP_ON?: boolean;
  unAuthQbp?: boolean;
  isAutoPay?: boolean;
  isPrePay?: boolean;
  unAuthCardInfo?: any;
  isUnAuthPa?: boolean;
  showTC?:boolean;
  retainformDataOnRevisit?:any;
  retainformData?:any;
}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    border: "solid 1px #000",
    backgroundColor: "#fff",
    fontSize: 16,
    width: "100%",
    padding: "8px 16px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000",
    },
  },
}));

const BootstrapAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      padding: "0px",
      border: "none",
      "& .MuiAutocomplete-input": {
        position: "relative",
        border: "solid 1px #000",
        backgroundColor: "#fff",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        transition: theme.transitions.create([
          "border-color",
          "background-color",
          "box-shadow",
        ]),
        "&:focus": {
          borderColor: "#000",
        },
      },
    },
  },
}));

const BootstrapSelect = styled(Select)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    position: "relative",
    border: "solid 1px #000",
    backgroundColor: "#fff",
    fontSize: 16,
    width: "100%",
    padding: "8px 6px 8px 10px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "&:focus": {
      borderColor: "#000",
    },
  },
}));


const inputLabelCss = {
  color: "#000",
  fontSize: "16px",
  // fontWeight: 600,
  "&.Mui-focused": {
    color: "#000",
  },
};

/* function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
} */

const AddPaymentMethodNew = (props: addpaymentMethodNew) => {
  const {
    onClose,
    onAddEditSuccess,
    card,
    fromEditCard = false,
    QBP_ON = false,
    isAutoPay = false,
    showApifailPopup,
    isPrePay = false,
    unAuthQbp = false,
    isUnAuthPa = false,
    showTC = false,
  } = props;

  const headers = useBrightspeedHeaders();
  const user = useAppSelector((state) => state.user.data);
  const userCompanyName = useAppSelector((state) => state?.user?.companyName);
  const sessionId = useAppSelector((state) => state?.user?.sessionId);
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const amsToken = useAppSelector((state) => state?.amsToken?.data);
  const { paymentMethods } = useAppSelector(
    (state) => state?.paymentMethods
  );
  const { defaultPaymentMethodId, creditcard } = paymentMethods || {};
  const { notificationViewSortedData: notificationSort } = useAppSelector(
    (state) => state?.notificationDetails
  );
  
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [suggetionsAddresses, setSuggetionsAddress] = useState<any[]>([]);
  const [showPass, setShowPass] = useState(false);
  const [showCreditCardnum, setShowCreditCardnum] = useState(false);
  const [paymentSignatureData, setPaymentSignatureData] = useState<any>(false);
  const [accId, setAccId] = useState("");
  const [paymentEncriptedCardInfo, setPaymentEncriptedCardInfo] =
    useState<any>(false);
  const [CC_DC_Name, set_CC_DC_Name] = useState("");
  const [cardImage, setCardImage] = useState<any>(false);
  const [isSubmitLoader, setIsSubmitLoader] = useState(false);
  const [isEditFormTidy, setIsEditFormTidy] = useState<any>(null);
  const [isUnAUthQbpFormTidy, setIsUnAUthQbpFormTidy] = useState<boolean>(
    unAuthQbp ? true : false
  );
  const [isUnAuthPAFormTidy,setIsUnAuthPAFormTidy] = useState<boolean>(isUnAuthPa ? true : false)
  const companyName: any = useAppSelector((state) => state.user.companyName);
  const quickBillPayPageContent: any = useAppSelector(
    (state) => state?.quickBillPayContent?.quickBillPayPageContent
  );
  const quickBillPay: any = QuickBillPay();
  const QBP_CONTENT_2: any = quickBillPay?.entry;
  
  const PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION =
    QBP_CONTENT_2?.paymentMethodSection?.addPaymentMethodSection?.credit_card_details;
  const PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION =
    QBP_CONTENT_2?.paymentMethodSection?.editPaymentMethodSection?.credit_card_details;
  const PAYMENT_METHOD_CREDIT_MANAGE_AUTOPAY_SECTION = QBP_CONTENT_2?.paymentMethodSection?.addBankAccount?.manageautopay;
  const PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION = QBP_CONTENT_2?.paymentMethodSection?.addBankAccount?.bank_account_details;
  const QBP_FLOW = QBP_CONTENT_2?.qbp_flow?.select_payment_method; 

  const {selectedPayArrangmentType,enteredPayAmount} = useAppSelector(
    (state) => state?.nonAuthPaymentArrangement
  );
    const { accountType } = useBrightspeedUser();
    const addressOneRef = useRef<HTMLDivElement>(null);
    const autocompleteStateRef =  useRef<HTMLSelectElement>(null);
    const checkboxRef = useRef<HTMLInputElement | null>(null);
  const PAY_PAL_DETAILS =
  QBP_CONTENT_2?.paymentMethodSection?.addPaymentMethodSection?.paypal_card_details;
  const getValidationSchema = (
    fromEditCard: boolean,
    QBP_ON: boolean,
    isAutoPay: boolean,
    showTC:boolean

  ) => {
    const creditCardNumberRegesSchema = yup
      .string()
      .required(
        `${PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardNumberMissingError}`
      )
      .default("")
      // .matches(/^[0-9 ]*$/, "Please enter a valid card number.")
      // .min(16, "Please enter a valid card number.")
      // .max(19, "Please enter a valid card number.")
      .matches(
        /^(2|4|5|6)/,
        PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.validCreditNo
      )
      .test(
        "cardType",
        `${PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardNumberMissingError}.`,
        validateCreditCardNumberAllowed
      )
      .nullable();

    const creditCardNumberWithoutRegesSchema = yup
      .string()
      .required(
        `${PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardNumberMissingError}.`
      )
      .nullable();

    const fullNameFromEdit = yup
      .string()
      .required(PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardholderName)
      // .matches(/^[a-zA-Z]+(?: [a-zA-Z'-]+)+$/, PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.InvalidCardholderName)
      .nullable();
    const fullNameSchema = yup
      .string()
      .required(PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardholderName)
      // .matches(/^[a-zA-Z]+(?: [a-zA-Z'-]+)+$/, PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.InvalidCardholderName)
      .nullable();


    const termsConditionSchema = //Work only for Non QBP scenarios
      (!showTC)
        ? yup.boolean().notRequired()
        : yup
            .boolean()
            .required(PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.paymentTermsAndConditionError)
            .oneOf(
              [true],
              (PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.paymentTermsAndConditionError)
            )
            .default(false);

    const addCardSchema = yup
      .object({
        creditCardNumber: fromEditCard
          ? creditCardNumberWithoutRegesSchema
          : creditCardNumberRegesSchema,
        fullName: fromEditCard ? fullNameFromEdit : fullNameSchema,
        expirationDate: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.ccDateMissingError}.`
          )
          .matches(
            /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/,
            PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.ccDateWrongError
          )
          .test(
            "validateExpirationDate",
            PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.ccDateWrongError,
            validateExpirationDate
          )
          .nullable(),
        cvv: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cvvMissingError}`
          )
          .matches(
            /^[0-9]{3}$/,
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cvvWrongError}`
          ) // keep cvv length is 3 as of now
          // .matches(/^[0-9]{3,4}$/, "Invalid CVV format")
          .nullable(),
        selectedCard: yup
          .string()
          .required(PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.paymentRequired)
          .nullable(),
        isPrimaryPaymentMethod: yup.boolean(),
        isSameAsServiceAddress: yup.boolean(),
        address1: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderStreetAddressMissingError}.`
          )
          .nullable(),
        //address2: yup.string().nullable(),
        city: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderCityMissingError}.`
          )
          .nullable(),
        state: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderStateMissingError}.`
          )
          .nullable()
          .notOneOf(
            ["State"],
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderStateMissingError}.`
          ),

        zipCode: yup
          .string()
          .required(
            `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderZipCodeMissingError}.`
          )
          .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardholderZipCodeMissingError)
          .nullable(),

        isTermsAndCondition: termsConditionSchema,
      })
      .required();

    return addCardSchema;
  };

  const addCardSchema = getValidationSchema(fromEditCard, QBP_ON, isAutoPay, showTC);


  const {
    qbp_cancel_form,
    qbp_add_credit_payment_method_attempted,
    qbp_update_credit_method_attempted,
    qbp_add_credit_method_successs,
    qbp_add_credit_method_failed,
    qbp_update_credit_method_success,
    qbp_update_credit_method_failed,

    unauthqbp_update_credit_method_attempted,
    unauthqbp_update_credit_method_success,
    unauthqbp_update_credit_method_failed,

    unauthqbp_cancel_step1,
    unauthqbp_add_cc_continue_step2,
    unauthqbp_add_credit_method_successs,
    unauthqbp_add_credit_method_failed,
    add_payment_method,
    update_pay_info,
    Pa_add_card_payment_method_success,
    Pa_add_card_payment_method_failure,
    Pa_edit_card_payment_method_success,
    Pa_edit_card_payment_method_failure,
    AP_add_PM_CD_card_cancel_cta,
    AP_edit_PM_CD_card_cancel_cta,
    AP_add_PM_CD_card_continue_cta,
    AP_edit_PM_CD_card_continue_cta,
    AP_add_PM_CD_card_sucess,
    AP_edit_PM_CD_card_failed,
    AP_add_PM_CD_card_failed,
    AP_edit_PM_CD_card_sucess
  } = EC_DW_LOGGING_STEPS

  const dwLogDefaults = {
    headers, 
    sessionId, 
    email: user?.email,
    companyName: userCompanyName,
  }

  const displayExpiryDate = (date: any) => {
    if (!date) return null;
    return `${date.slice(0, 2)}/20${date.slice(-2)}`;
  };
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    trigger,
    setFocus,
    formState: { errors, isDirty,isSubmitted },
  } = useForm({
    resolver: yupResolver(addCardSchema),
    shouldFocusError: true,
    mode: "onBlur",
    reValidateMode: "onBlur",
    //mode: "onChange",
    defaultValues: {
      creditCardNumber:
        props.retainformData?.creditCardNumber 
        || (card?.creditCardNumber && getCardNumberWithMasking(card?.creditCardNumber))
        || null,
      fullName: props.retainformData?.fullName || card?.fullName || null,
      expirationDate: props.retainformData?.expirationDate || displayExpiryDate(card?.expiryDate),
      cvv: props.retainformData?.cvv || card?.cvv || null,
      selectedCard: "Credit Card",
      isPrimaryPaymentMethod: card?.cardId === defaultPaymentMethodId,
      isSameAsServiceAddress: false,
      address1: props.retainformData?.address1 || card?.address1 || "",
      city: props.retainformData?.city || card?.city || null,
      zipCode: props.retainformData 
                ? props.retainformData?.zipCode
                : card?.city 
                  ? card?.zipCode
                  : null,
      // zipCode: props.retainformData?.zipCode || (card && card?.city) ? card?.zipCode || null:null, // Check this condition once speed pay providing full address details
      state: props.retainformData?.state || card?.state || "State",
      isTermsAndCondition: props.retainformData?.isTermsAndCondition || false,
    },
  });

  useEffect(() => {
    const serviceAdd = user?.addresses?.find(
      (addr: any) => addr?.addressType === "ServiceAddress"
    );
    if (
      card?.creditCardNumber &&
      fromEditCard &&
      !isDirty &&
      serviceAdd?.street
    ) {
      if (
        serviceAdd?.street?.trim()?.toUpperCase() ===
          card?.address1?.trim()?.toUpperCase() &&
        serviceAdd?.city?.trim()?.toUpperCase() ===
          card?.city?.trim()?.toUpperCase() &&
        serviceAdd?.zip?.trim() === card?.zipCode?.trim()
      ) {
        setValue("isSameAsServiceAddress", true);
      } else {
        setValue("isSameAsServiceAddress", false);
      }
      setShowCreditCardnum(true);
    } else if (!fromEditCard && !isDirty && serviceAdd?.street && !unAuthQbp) {
      setValue("isSameAsServiceAddress", true);
      setValue("address1", serviceAdd?.street?.trim());
      setValue("city", serviceAdd?.city?.trim());
      setValue(
        "state",
        StateList?.find(
          (state: any) =>
            state?.abbreviation === serviceAdd?.state ||
            state?.name === serviceAdd?.state
        )?.abbreviation || ""?.trim()
      );
      setValue("zipCode", serviceAdd?.zip?.trim());
    }

    if(!defaultPaymentMethodId){
      setValue("isPrimaryPaymentMethod", true);
    }
  }, [card]);

   useEffect(() => {
      // Automatically focus on the first error field
      if (isSubmitted && Object.keys(errors).length > 0) {
        const firstErrorField: any = Object.keys(errors)[0];
        setFocus(firstErrorField);
        firstErrorField === "address1" && addressOneRef?.current?.querySelector('input')?.focus();
        firstErrorField === "isTermsAndCondition" && checkboxRef.current?.focus();
        try {
          if (firstErrorField === "state") {
            let errorField: Element | any = autocompleteStateRef?.current?.querySelector('input,[tabindex]:not([tabindex="-1"])');
            errorField?.focus?.();
          }
        } catch (error) {
          console.error("catch error", error);
        }      
      }  
    }, [errors, isSubmitted])

  useEffect(() => {
    if (!fromEditCard) {
      //getPayemntTokenAndSignature();
    }
    dispatch(getAMSToken());
    if(!quickBillPayPageContent) {
    dispatch(getquickBillPayPageContent());
    }
  }, []);

  const getEncryptValue = async (text: any, key: any) => {
    const encryptData = await encryptNativeSpeedPay(text, key);
    setPaymentEncriptedCardInfo(encryptData);
  };
  useEffect(() => {
    if (
      watch("creditCardNumber") &&
      watch("cvv") &&
      watch("expirationDate") &&
      validateCreditCardNumberAllowed(watch("creditCardNumber") || "")
    ) {
      const expirationDate = watch("expirationDate");
      const cardNo = watch("creditCardNumber");
      if (cardNo && cardNo?.length && validateCreditCardNumberAllowed(cardNo)) {
        set_CC_DC_Name(getCardTypeByCardNumber(cardNo?.replaceAll(" ", "")));
      }
      if (expirationDate) {
        const expirationDateSlitData = expirationDate?.split("/");
        const expirationMonth = expirationDateSlitData[0];
        const expirationYear = parseInt(
          expirationDateSlitData[1]?.length > 2
            ? expirationDateSlitData[1]?.slice(2)
            : expirationDateSlitData[1]
        );

        /* Edit Payment  */
        const editPaymentSkipCard = fromEditCard
          ? ""
          : "#" + watch("creditCardNumber")?.replaceAll(" ", "")?.trim();
        const unencrypted_values =
          editPaymentSkipCard +
          "#" +
          watch("cvv") +
          "#" +
          expirationMonth +
          "#" +
          expirationYear;

        const encryptedCardInfo = getEncryptValue(
          unencrypted_values,
          publicKeySpeedPay
        );
      }
    } else if (watch("cvv") && watch("expirationDate") && fromEditCard) {
      const expirationDate = watch("expirationDate");
      if (expirationDate) {
        //const expirationMonth = parseInt(expirationDate?.split("/")[0]);
        const expirationDateSlitData = expirationDate?.split("/");
        const expirationMonth = expirationDateSlitData[0];
        const expirationYear = parseInt(
          expirationDateSlitData[1]?.length > 2
            ? expirationDateSlitData[1]?.slice(2)
            : expirationDateSlitData[1]
        );

        watch("creditCardNumber")?.replaceAll(" ", "")?.trim();
        const unencrypted_values =
          "##" + watch("cvv") + "#" + expirationMonth + "#" + expirationYear;
        const encryptedCardInfo = getEncryptValue(
          unencrypted_values,
          publicKeySpeedPay
        );
      }
    }
  }, [watch("creditCardNumber"), watch("cvv"), watch("expirationDate")]);

  useEffect(() => {
    if (!fromEditCard && watch("selectedCard") === "Credit Card") {
      window?.localStorage?.setItem(
        "creditCard_IsPrimaryPaymentMethod",
        JSON?.stringify(watch("isPrimaryPaymentMethod"))
      );
    }
  }, [watch("isPrimaryPaymentMethod")]);

  useEffect(() => {
    if (!fromEditCard && watch("isSameAsServiceAddress")) {
      const serviceAdd = user?.addresses?.find(
        (addr: any) => addr?.addressType === "ServiceAddress"
      );
      if (
        serviceAdd?.street?.trim()?.toUpperCase() !==
        watch("address1")?.trim()?.toUpperCase()
      ) {
        setValue("isSameAsServiceAddress", false);
      }
    }
  }, [watch("address1")]);

  const  getPayKind=async(id:any)=>{
    let card= creditcard.filter((item:any)=>{
      return item?.id===id
    })[0];
    return card?.type==="ATM" ? "DebitCard" : "CreditCard"
  }

  // To check Edit Form is Tidy - Enables Continue button
  useEffect(() => {
    if (fromEditCard) {
      if (!isEditFormTidy) {
        setIsEditFormTidy(true);
      }

      if (
        watch("cvv") !== null ||
        watch("address1") !== card?.address1 ||
        watch("city") !== card?.city ||
        watch("state") !== card?.state ||
        watch("zipCode") !== card?.zipCode ||
        watch("expirationDate") !== displayExpiryDate(card?.expiryDate)
      ) {
        setIsEditFormTidy(false);
      }
    }

    if(isUnAuthPa && !fromEditCard) {
      if (
        watch("cvv") &&
        watch("address1")  &&
        watch("city")  &&
        watch("state") !== "State" &&
        watch("zipCode")  &&
        watch("expirationDate") 
      ) {
        setIsUnAuthPAFormTidy(false);
      }else{
        setIsUnAuthPAFormTidy(true);
      }
    }
    if(isUnAuthPa && fromEditCard) {
      if (
        watch("cvv") &&
        watch("address1")  &&
        watch("city")  &&
        watch("state") !== "State" &&
        watch("zipCode")  &&
        watch("expirationDate") 
      ) {
        setIsUnAuthPAFormTidy(false);
      }else{
        setIsUnAuthPAFormTidy(true);
      }
    }
    if(unAuthQbp) {
      if (
        watch("cvv") &&
        watch("address1")  &&
        watch("city")  &&
        watch("state") !== "State" &&
        watch("zipCode")  &&
        watch("expirationDate") 
        // watch("isTermsAndCondition") 
      ) {
        
        setIsUnAUthQbpFormTidy(false);
      }else{
        setIsUnAUthQbpFormTidy(true);
      }
    }
  }, [
    watch("expirationDate"),
    watch("cvv"),
    watch("address1"),
    watch("city"),
    watch("state"),
    watch("zipCode"),
    // watch("isTermsAndCondition"),
    enteredPayAmount,
    selectedPayArrangmentType
  ]);

  const getPayemntTokenAndSignature = async () => {
    try {
      let url=ApiUrls['paymentTokenUrl'];
      const tokenResponse = await paymentGenerateToken(
        {
          [url]: "",
        },
        {}, // empty body object
        headers
      );
      if (
        tokenResponse?.data &&
        tokenResponse?.status === 200 &&
        tokenResponse?.data?.access_token
      ) {
        const accountSummaryRes = await getAccountSummary(
          {
            [ApiUrls?.accountId_QA_Url]: user?.billingAccountNumber,
          },
          { headers }
        );

        if (accountSummaryRes?.data?.accountId) {
          setAccId(accountSummaryRes?.data?.accountId);
          const paymentSignatureResponse = await paymentGenerateSignature(
            {
              [ApiUrls?.paymentGenerateSignatureUrl]: `${tokenResponse?.data?.access_token}?pageIndicator=ACM`,
            },
            {}, // empty body object
            headers
          );
          if (
            paymentSignatureResponse?.data &&
            paymentSignatureResponse?.data?.success &&
            paymentSignatureResponse?.status === 200
          ) {
            setPaymentSignatureData(paymentSignatureResponse?.data);
          }
        } else {
          setAccId("");
          setPaymentSignatureData(false);
        }
      }
    } catch (error) {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "zora get token and signature",
        error,
        undefined,
        sessionId,
        user.billingAccountNumber,
        userCompanyName,
        true
      );
      console.error(error);
    }
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const onSubmit = async (data: any) => {
    addEneventGTM(
      fromEditCard
        ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.saveButtonLabel
        : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.saveButtonLabel,
      sessionId,
      user.billingAccountNumber,
      userCompanyName || headers?.siteId
    );

    /** For Non auth flow, when user goes back and submits same form data */
    if(unAuthQbp) {
      const {creditCardNumber, retainPaymentAuthId} = props?.retainformData
      
      if(unAuthQbp && creditCardNumber === data?.creditCardNumber?.replace(/\s+/g, "")){
        props.unAuthCardInfo({
          id: retainPaymentAuthId,
          cardNumber: data?.creditCardNumber?.replace(/\s+/g, ""),
          creditCardType: cardImage,
          paymentType: "Card",
          accountHolderInfo: {
            accountHolderName: data?.fullName,
            zipCode: user?.addresses?.find(
              (addr: any) => addr?.addressType === "ServiceAddress"
            ).zip,
          },
        });

        // props.retainformDataOnRevisit ({
        //   retainPaymentAuthId,
        //   creditCardNumber: data?.creditCardNumber?.replace(/\s+/g, ""),
        //   fullName: data?.fullName,
        //   expirationDate: data?.expirationDate && displayExpiryDate(data?.expirationDate),
        //   cvv: data?.cvv,
        //   selectedCard: "Credit Card",
        //   isSameAsServiceAddress: false,
        //   address1: data?.address1,
        //   city: data?.city,
        //   zipCode: data?.zipCode,
        //   state: data?.state,
        //   isTermsAndCondition: true,
        // });

        DwLogutil({stepName: unauthqbp_add_credit_method_successs})
        sendEventLog(unauthqbp_add_credit_method_successs, {unauthqbp_add_credit_method_successs: unauthqbp_add_credit_method_successs});
        sendEventGTMLog(unauthqbp_add_credit_method_successs, headers?.siteId || userCompanyName);
        return onAddEditSuccess();
      }
    }

    if(unAuthQbp || isUnAuthPa || QBP_ON ) {
       setIsSubmitLoader(true) 
    };

    try {
      // const paymentMethodKind = (card?.paymentMethodKind && 
      //                             card?.paymentMethodKind?.toUpperCase() === 'ATM')
      //                             ? "DebitCard" : "CreditCard"

      const paymentMethodKind = await getPayKind(card?.cardId);
      dispatch(onAddEditPaymentMethodLoadingStart());
      const stateAbbreviation = StateList?.find(
        (state: any) => state?.abbreviation === data?.state
      );
      if(isAutoPay){DwLogutil({stepName:(fromEditCard)?AP_edit_PM_CD_card_continue_cta:AP_add_PM_CD_card_continue_cta})}
      if(isPrePay) {DwLogutil({stepName:(fromEditCard) ? EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_cta : EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_cta})}
      if(isPrePay){ 
        {sendEventLog(fromEditCard ? EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_cta : EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_cta,
           {
        pre_update_CD_Pay_cta: EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_cta
        });
      };
      sendEventGTMLog(fromEditCard ? EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_cta : EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_cta, headers?.siteId || userCompanyName)
     }

      if (fromEditCard) {
        /* Edit payment info */
        if(QBP_ON) {
          DwLogutil({stepName: qbp_update_credit_method_attempted})
          sendEventLog(qbp_update_credit_method_attempted, {
            qbp_update_credit_method_attempted: qbp_update_credit_method_attempted
          });
          sendEventGTMLog(qbp_update_credit_method_attempted, headers?.siteId  || userCompanyName)
          }

        const response = await updatePaymentMethod(
          { [ApiUrls.updatePaymentMethodUrl_QA]: card?.cardId },
          {
            baseline: {
              siteId: headers?.siteId?.toLowerCase(),
              billingType: user?.billingType,
              transactionId: uuidv4(),
            },
            street: data?.address1,
            city: data?.city,
            state: stateAbbreviation?.abbreviation,
            zip: data?.zipCode,
            /*  encFields: "#field_cardSecurityCode#field_creditCardExpirationMonth#field_creditCardExpirationYear", */
            cardHolderName: data?.fullName,
            banNumber: user?.billingAccountNumber,
            kind: "Card",
            paymentMethodKind,
            encValues: paymentEncriptedCardInfo,
            /*  gatewayOptions: {
                  value: "Paymentech Orbital Gateway",
                }, */
            defaultPaymentMethod:
              isAutoPay
              ? defaultPaymentMethodId === card?.cardId
                ? false
                : data?.isPrimaryPaymentMethod
              : (data?.isPrimaryPaymentMethod)?data?.isPrimaryPaymentMethod:false,
            //cardNumber: data?.creditCardNumber,
            billingType: user?.billingType,
            email: user?.email,
          },
          headers
        );
        if (unAuthQbp) {
          DwLogutil({ stepName: unauthqbp_update_credit_method_attempted })
          sendEventLog(unauthqbp_update_credit_method_attempted, {
            unauthqbp_update_credit_method_attempted: unauthqbp_update_credit_method_attempted
          });
          sendEventGTMLog(unauthqbp_update_credit_method_attempted, headers?.siteId || userCompanyName)
        }
        dispatch(onAddEditPaymentMethodLoadingStop());
        // const stepName = 
        // QBP_ON 
        // ? qbp_update_credit_method
        // : isUnAuthPa
        // ? EC_DW_LOGGING_STEPS.Pa_edit_payment_method_success
        // : update_pay_info

        if (response?.status === 200 && response?.data?.success === "true") {
          if(!isAutoPay){
            toast.success(
              PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.updatedPaymentMethodSuccessMsg?.replace(
                "<VALUE>", watch("selectedCard")
              ), {
                icon: <ToastCustonIcon type="success" />,
              }
            );
          }
          AddUpdatePaymentGTM("update_payment_info_success",userCompanyName || headers?.siteId,"",accountType,user?.billingAccountNumber)
          onAddEditSuccess();
          onClose();
          dispatch(setShowEditPaymentPopUp(false));
          /* addEneventGTM(
              fromEditPayment
                  ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.saveButtonLabel
                  : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.saveButtonLabel,
              sessionId,
              user.billingAccountNumber,
              userCompanyName
          ); */
          if (QBP_ON) {
            DwLogutil({ stepName: qbp_update_credit_method_success });
            sendEventLog(qbp_update_credit_method_success, {
              qbp_update_credit_method_success: qbp_update_credit_method_success
            });
            sendEventGTMLog(qbp_update_credit_method_success, headers?.siteId  || userCompanyName)
          }
          if (unAuthQbp) {
            DwLogutil({ stepName: unauthqbp_update_credit_method_success });
            sendEventLog(unauthqbp_update_credit_method_success, {
              unauthqbp_update_credit_method_success: unauthqbp_update_credit_method_success
            });
            sendEventGTMLog(unauthqbp_update_credit_method_success, headers?.siteId || userCompanyName)
          }
          if (isUnAuthPa) {
            DwLogutil({ stepName: Pa_edit_card_payment_method_success });
            sendEventLog(Pa_edit_card_payment_method_success, {
              Pa_edit_card_payment_method_success: Pa_edit_card_payment_method_success
            });
            sendEventGTMLog(Pa_edit_card_payment_method_success, headers?.siteId || userCompanyName)
            addEneventGTM(
              Pa_edit_card_payment_method_success,
              sessionId,
              user?.billingAccountNumber,
              companyName
            );  
          }
          if (isAutoPay) {
            DwLogutil({ stepName: AP_edit_PM_CD_card_sucess });
            sendEventLog(AP_edit_PM_CD_card_sucess, {AP_edit_PM_CD_card_sucess: AP_edit_PM_CD_card_sucess});
            sendEventGTMLog(AP_edit_PM_CD_card_sucess, headers?.siteId || userCompanyName)
          }
          if(isPrePay) {
            DwLogutil({stepName: EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_sucess});
            sendEventLog(EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_sucess, {
              pre_update_CD_Pay_sucess: EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_sucess
            });
            sendEventGTMLog(EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_sucess, headers?.siteId || userCompanyName)
          }

          /** Unauth QBP - data object, set as Prop for Verify & Confirm page  */
        } else {
          toast.error(
            `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.editPaymentFailureResponse}`,
            {
              icon: <ToastCustonIcon type="error" />,
            }
          );
           AddUpdatePaymentGTM("update_payment_info_failed",userCompanyName || headers?.siteId,"Update payment method failed with api statusCode 200",accountType,user?.billingAccountNumber)
          DwLogutil({
            ...dwLogDefaults,
            error: 'Error with 200',
            stepName: QBP_ON 
              ? EC_DW_LOGGING_STEPS?.qbp_update_credit_method_failed
              : isUnAuthPa 
                ? EC_DW_LOGGING_STEPS?.Pa_edit_card_payment_method_failure
                : unAuthQbp
                  ? EC_DW_LOGGING_STEPS?.unauthqbp_update_credit_method_failed
                  : isAutoPay 
                    ? EC_DW_LOGGING_STEPS?.AP_edit_PM_CD_card_failed
                    : isPrePay
                      ? EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail
                      : ""
          })
          sendEventLog(
            QBP_ON
              ? EC_DW_LOGGING_STEPS?.qbp_update_credit_method_failed
              : isUnAuthPa
                ? EC_DW_LOGGING_STEPS?.Pa_edit_card_payment_method_failure
                : unAuthQbp
                  ? EC_DW_LOGGING_STEPS?.unauthqbp_update_credit_method_failed
                  : isAutoPay
                    ? EC_DW_LOGGING_STEPS?.AP_edit_PM_CD_card_failed
                    : isPrePay
                      ? EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail
                      : ""
            , {qbp_update_credit_method_failed: EC_DW_LOGGING_STEPS?.qbp_update_credit_method_failed});
            sendEventGTMLog( QBP_ON
              ? EC_DW_LOGGING_STEPS?.qbp_update_credit_method_failed
              : isUnAuthPa
                ? EC_DW_LOGGING_STEPS?.Pa_edit_card_payment_method_failure
                : unAuthQbp
                  ? EC_DW_LOGGING_STEPS?.unauthqbp_update_credit_method_failed
                  : isAutoPay
                    ? EC_DW_LOGGING_STEPS?.AP_edit_PM_CD_card_failed
                    : isPrePay
                      ? EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail
                      : "", headers?.siteId || userCompanyName)
            
        }
      } 
      else {
        /* Add Paymant */
        if(QBP_ON) {
          DwLogutil({stepName: qbp_add_credit_payment_method_attempted});
          sendEventLog(qbp_add_credit_payment_method_attempted, {
            qbp_add_credit_payment_method_attempted: qbp_add_credit_payment_method_attempted
          });
           sendEventGTMLog( qbp_add_credit_payment_method_attempted, headers?.siteId || userCompanyName)
        }

        const classValue = data?.creditCardNumber?.replaceAll(" ", "")?.slice(0, 6) ;
        let url=ApiUrls.addAutoPaymentMethodUrl_QA;
        const response = await submitAutoPaymentMethod(
          { "": unAuthQbp ? ApiUrls.purlPaymentAuthId : url },
          {
            baseline: {
              siteId: headers?.siteId?.toLowerCase(),
              billingType: user?.billingType,
              transactionId: uuidv4(),
              channel: "web-acm",
            },
            street: data?.address1,
            city: data?.city,
            state: stateAbbreviation?.abbreviation,
            zip: data?.zipCode,
            encFields:
              "#field_creditCardNumber#field_cardSecurityCode#field_creditCardExpirationMonth#field_creditCardExpirationYear",
            cardHolderName: data?.fullName,
            creditAccount: user?.billingAccountNumber,
            paymentType: "Card",
            paymentMethodKind: "creditcard",
            kind: "Card",
            encValues: paymentEncriptedCardInfo,
            defaultPaymentMethod: isAutoPay ? data?.isPrimaryPaymentMethod : (data?.isPrimaryPaymentMethod)?data?.isPrimaryPaymentMethod:false,
            billingType: user?.billingType,
            email: user?.email,
            classValue
          },
          headers
        );

        if(unAuthQbp) {
          if (response?.data?.paymentAuthId) {
            localStorage.setItem("paymentAuthId",response?.data?.paymentAuthId);
            props.unAuthCardInfo({
              id: response?.data?.paymentAuthId,
              cardNumber: data?.creditCardNumber?.replace(/\s+/g, ""),
              creditCardType: cardImage,
              paymentType: "Card",
              accountHolderInfo: {
                accountHolderName: data?.fullName,
                zipCode: user?.addresses?.find(
                  (addr: any) => addr?.addressType === "ServiceAddress"
                ).zip,
              },
            });
            // props.retainformDataOnRevisit ({
            //   retainPaymentAuthId: response?.data?.paymentAuthId,
            //   creditCardNumber: data?.creditCardNumber?.replace(/\s+/g, ""),
            //   fullName: data?.fullName,
            //   expirationDate: data?.expirationDate && displayExpiryDate(data?.expirationDate),
            //   cvv: data?.cvv,
            //   selectedCard: "Credit Card",
            //   isSameAsServiceAddress: false,
            //   address1: data?.address1,
            //   city: data?.city,
            //   zipCode: data?.zipCode,
            //   state: data?.state,
            //   isTermsAndCondition: true,
            // });
            onAddEditSuccess();
            DwLogutil({stepName: unauthqbp_add_credit_method_successs});
            sendEventLog(unauthqbp_add_credit_method_successs, {
              unauthqbp_add_credit_method_successs: unauthqbp_add_credit_method_successs
            });
            sendEventGTMLog( unauthqbp_add_credit_method_successs, headers?.siteId || userCompanyName)
            toast.success( "You have successfully added your Credit card information", {
              icon: <ToastCustonIcon type="success" />,
            });
            AddUpdatePaymentGTM("add_payment_info_success",userCompanyName || headers?.siteId,"",accountType,user?.billingAccountNumber)
            onClose();
          } 
          else {
            const responseMessage = response?.data?.paymentResponse?.message
            DwLogutil({stepName: unauthqbp_add_credit_method_failed, error: responseMessage})
            sendEventLog(unauthqbp_add_credit_method_failed, {
              unauthqbp_add_credit_method_failed: unauthqbp_add_credit_method_failed
            });
            sendEventGTMLog( unauthqbp_add_credit_method_failed, headers?.siteId || userCompanyName)
            toast.error("Something went wrong while adding payment method.", {
              icon: <ToastCustonIcon type="error" />, 
            });
          showApifailPopup();
            AddUpdatePaymentGTM("add_payment_info_failed",userCompanyName || headers?.siteId, responseMessage, accountType,user?.billingAccountNumber)
          }
          dispatch(onAddEditPaymentMethodLoadingStop());
          onClose();
          return true;
        }

        if(response) {
          setIsSubmitLoader(false);
          // !unAuthQbp && onClose();
          onClose();
          dispatch(setShowEditPaymentPopUp(false));
          //dispatch(setShowEditPaymentPopUp(false));
          onAddEditSuccess();

          /** Unauth QBP - data object, set as Prop for Verify & Confirm page  */
          // props.unAuthCardInfo({
          //   id: response?.data?.paymentAuthId,
          //   cardNumber: data?.creditCardNumber?.replace(/\s+/g, ""),
          //   creditCardType: cardImage,
          //   paymentType: "Card",
          //   accountHolderInfo: {
          //     accountHolderName: data?.fullName,
          //     zipCode: user?.addresses?.find(
          //       (addr: any) => addr?.addressType === "ServiceAddress"
          //     ).zip,
          //   },
          // });
          // props.retainformDataOnRevisit ({
          //   retainPaymentAuthId: response?.data?.paymentAuthId,
          //   creditCardNumber: data?.creditCardNumber?.replace(/\s+/g, ""),
          //   fullName: data?.fullName,
          //   expirationDate: data?.expirationDate && displayExpiryDate(data?.expirationDate),
          //   cvv: data?.cvv,
          //   selectedCard: "Credit Card",
          //   isSameAsServiceAddress: false,
          //   address1: data?.address1,
          //   city: data?.city,
          //   zipCode: data?.zipCode,
          //   state: data?.state,
          //   isTermsAndCondition: true,
          // });

          if(QBP_ON) {
            DwLogutil({stepName: qbp_add_credit_method_successs});
            sendEventLog(qbp_add_credit_method_successs, {
              qbp_add_credit_method_successs: qbp_add_credit_method_successs
            });
            sendEventGTMLog( qbp_add_credit_method_successs, headers?.siteId || userCompanyName)
          }
          if(isUnAuthPa) {
            DwLogutil({stepName: Pa_add_card_payment_method_success})
            sendEventLog(Pa_add_card_payment_method_success, {
              Pa_add_card_payment_method_success: Pa_add_card_payment_method_success
            });
            addEneventGTM(
              Pa_add_card_payment_method_success,
              sessionId,
              user?.billingAccountNumber,
              companyName
            );  
          }
          if(isAutoPay) {
            DwLogutil({stepName: AP_add_PM_CD_card_sucess});
            sendEventLog(AP_add_PM_CD_card_sucess, {
              AP_add_PM_CD_card_sucess: AP_add_PM_CD_card_sucess
            });
              sendEventGTMLog( AP_add_PM_CD_card_sucess, headers?.siteId || userCompanyName)
          }
          if(isPrePay) {
            DwLogutil({stepName: EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_sucess});
            sendEventLog(EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_sucess, {
              pre_add_CD_Pay_sucess: EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_sucess
            });
            sendEventGTMLog( EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_sucess, headers?.siteId || userCompanyName)
          } 
          if(!isAutoPay){
            toast.success(response?.data?.message || "Success" , {
              icon: <ToastCustonIcon type="success" />,
            });
          }  
          AddUpdatePaymentGTM("add_payment_info_success",userCompanyName || headers?.siteId,"",accountType,user?.billingAccountNumber)
          dispatch(onAddEditPaymentMethodLoadingStop());
        }
      }
    } catch (error: any) {
      const errMsg = error?.response?.data?.exception?.message || error?.message || "Error"
      setIsSubmitLoader(false);
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "edit payment method",
        error,
        undefined,
        sessionId,
        user.billingAccountNumber,
        userCompanyName,
        true
      );
      dispatch(onAddEditPaymentMethodLoadingStop());

      if (unAuthQbp) {
        clearForm();
        // props.retainformDataOnRevisit ({
        //   creditCardNumber: null,
        //   fullName: null,
        //   expirationDate: null,
        //   cvv: null,
        //   selectedCard: "Credit Card",
        //   isSameAsServiceAddress: false,
        //   address1: null,
        //   city: null,
        //   zipCode: null,
        //   state: null,
        //   isTermsAndCondition: false,
        // });
      }

      console.error(error);
      /* toast.error(
        fromEditCard
          ? `${PAYMENT_METHOD_CREDIT_ADD_BANK_SECTION?.editPaymentFailureResponse}`
          : "Something went wrong while adding payment method.",
        {
          icon: <ToastCustonIcon type="error" />,
        }
      ); */
     
          // const stepName= 
          // fromEditCard && (!unAuthQbp && !isUnAuthPa)
          // ? update_pay_info
          // :fromEditCard && isUnAuthPa
          // ? EC_DW_LOGGING_STEPS.Pa_edit_payment_method_failure
          // :isUnAuthPa
          // ? EC_DW_LOGGING_STEPS.Pa_add_payment_method_failure
          // : unAuthQbp ? `on payment arrangment-Step2of3 | ${add_payment_method}` : add_payment_method;
      
      if(fromEditCard) {
        if (QBP_ON) {
          DwLogutil({ stepName: qbp_update_credit_method_failed, error: errMsg });
          sendEventLog(qbp_update_credit_method_failed, {
            qbp_update_credit_method_failed: qbp_update_credit_method_failed
          });
          sendEventGTMLog(qbp_update_credit_method_failed, headers?.siteId || userCompanyName)
        } 
        if(unAuthQbp) {
          DwLogutil({stepName: unauthqbp_update_credit_method_failed, error: errMsg});
          sendEventLog(unauthqbp_update_credit_method_failed, {
            unauthqbp_update_credit_method_failed: unauthqbp_update_credit_method_failed
          });
          sendEventGTMLog(unauthqbp_update_credit_method_failed, headers?.siteId || userCompanyName)
        }
        if(isUnAuthPa) {
          DwLogutil({stepName: Pa_edit_card_payment_method_failure, error: errMsg});
          sendEventLog(Pa_edit_card_payment_method_failure, {
            Pa_edit_card_payment_method_failure: Pa_edit_card_payment_method_failure
          });
          addEneventGTM(
            Pa_edit_card_payment_method_failure,
            sessionId,
            user?.billingAccountNumber,
            companyName
          );  
        }
        if(isAutoPay) {
          DwLogutil({stepName: AP_edit_PM_CD_card_failed, error: errMsg});
          sendEventLog(AP_edit_PM_CD_card_failed, {
            AP_edit_PM_CD_card_failed: AP_edit_PM_CD_card_failed
          });
           sendEventGTMLog(AP_edit_PM_CD_card_failed, headers?.siteId || userCompanyName)
        }
        if(isPrePay) {
          DwLogutil({stepName: EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail, error: errMsg});
          sendEventLog(EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail, {
            pre_update_CD_Pay_fail: EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail
          });
           sendEventGTMLog(EC_DW_LOGGING_STEPS?.pre_update_CD_Pay_fail, headers?.siteId || userCompanyName)
        }
        AddUpdatePaymentGTM("update_payment_info_failed",userCompanyName || headers?.siteId,error?.response?.data?.exception?.message || error?.message || "Update payment method failed from catch block",accountType,user?.billingAccountNumber)

      } 
      else {
        if(QBP_ON) {
          DwLogutil({stepName: qbp_add_credit_method_failed, error: errMsg});
          sendEventLog(qbp_add_credit_method_failed, {
            qbp_add_credit_method_failed: qbp_add_credit_method_failed
          });
          sendEventGTMLog(qbp_add_credit_method_failed, headers?.siteId || userCompanyName)
        }
        if(unAuthQbp) {
          DwLogutil({stepName: unauthqbp_add_credit_method_failed, error: errMsg});
          sendEventLog(unauthqbp_add_credit_method_failed, {
            unauthqbp_add_credit_method_failed: unauthqbp_add_credit_method_failed
          });
           sendEventGTMLog(unauthqbp_add_credit_method_failed, headers?.siteId || userCompanyName)
        }
        if(isUnAuthPa) {
          DwLogutil({stepName: Pa_add_card_payment_method_failure, error: errMsg});
          sendEventLog(Pa_add_card_payment_method_failure, {
            Pa_add_card_payment_method_failure: Pa_add_card_payment_method_failure
          });
          addEneventGTM(
            Pa_add_card_payment_method_failure,
            sessionId,
            user?.billingAccountNumber,
            companyName
          );  
        }
        if(isAutoPay) {
          DwLogutil({stepName: AP_add_PM_CD_card_failed, error: errMsg});
          sendEventLog(AP_add_PM_CD_card_failed, {
            AP_add_PM_CD_card_failed: AP_add_PM_CD_card_failed
          });
          sendEventGTMLog(AP_add_PM_CD_card_failed, headers?.siteId || userCompanyName)
        }
        if(isPrePay) {
          DwLogutil({stepName: EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_fail, error: errMsg});
          sendEventLog(EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_fail, {
            pre_add_CD_Pay_fail: EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_fail
          });
          sendEventGTMLog( EC_DW_LOGGING_STEPS?.pre_add_CD_Pay_fail, headers?.siteId || userCompanyName)
        }  
       AddUpdatePaymentGTM("add_payment_info_failed",userCompanyName || headers?.siteId,error?.response?.data?.exception?.message || error?.message || "Add payment method failed from catch block",accountType,user?.billingAccountNumber)

      }
    
      
  
      !unAuthQbp && onClose();
      dispatch(setaddPaymentMethodError(error?.response?.data?.exception));
      showApifailPopup();
      dispatch(setShowEditPaymentPopUp(false));
    }
  };

  const onPaypal = async () => {
    try {
      const payload = {
        baseline: {
          siteId: headers?.siteId?.toLowerCase(),
          transactionId: uuidv4(),
          channel: "web-acm",
        },
        amount: "",
        flow: "",
        fiber: "",
      };
      const paypalTokenAPI_Res = await paypalTokenDetails(
        {
          [ApiUrls?.paypalUrl]: "paypal-token",
        },
        payload,
        headers
      );

      if (paypalTokenAPI_Res?.data && paypalTokenAPI_Res?.data?.data?.href) {
        DwLogutil({
          stepName: EC_DW_LOGGING_STEPS?.prepay_ctl_paypal_BA_toakn_success,
        });
        sendEventLog(EC_DW_LOGGING_STEPS?.prepay_ctl_paypal_BA_toakn_success, {
          prepay_ctl_paypal_BA_toakn_success: EC_DW_LOGGING_STEPS?.prepay_ctl_paypal_BA_toakn_success
        });
        sendEventGTMLog( EC_DW_LOGGING_STEPS?.prepay_ctl_paypal_BA_toakn_success, headers?.siteId || userCompanyName)
        const BA_Token = paypalTokenAPI_Res?.data?.data?.href?.split("=")[1];
        
        localStorage?.setItem("ctl_BA_Token", JSON?.stringify(BA_Token));
        const BATokenWithLink = paypalTokenAPI_Res?.data?.data?.href;
        window?.open(BATokenWithLink, "_self");
      } else {
        toast.error(
          "Something went wrong while adding paypal payment method.",
          {
            icon: <ToastCustonIcon type="error" />,
          }
        );
        DwLogutil({
          stepName: EC_DW_LOGGING_STEPS?.prepay_ctl_paypal_BA_toakn_fail,
          error: "CTL Prepay BA tokent not generated.",
        });
      }
    } catch (error: any) {
      toast.error("Something went wrong while adding paypal payment method.", {
        icon: <ToastCustonIcon type="error" />,
      });
      DwLogutil({
        stepName: EC_DW_LOGGING_STEPS?.prepay_ctl_paypal_BA_toakn_fail,
        error:
          error?.response?.data?.error_description ||
          error?.response?.data?.message ||
          "Catch block CTL prepay paypal token API fail.",
      });

      console.error(error);
    }
  };
  const clearForm = () => {
    addEneventGTM(
      "EC_Payment_method_clearall_link_click",
      sessionId,
      user?.billingAccountNumber,
      userCompanyName
    );
    reset(
      fromEditCard
        ? {
            selectedCard: "Credit Card",
            fullName: card?.fullName,
            creditCardNumber:
              card?.creditCardNumber &&
              getCardNumberWithMasking(card?.creditCardNumber),
            expirationDate: null,
            cvv: null,
            isPrimaryPaymentMethod: false,
            isSameAsServiceAddress: false,
            address1: "",
            city: null,
            zipCode: null,
            state: "State",
            isTermsAndCondition: false,
          }
        : {
            creditCardNumber: null,
            fullName: null,
            expirationDate: null,
            cvv: null,
            selectedCard: "Credit Card",
            isPrimaryPaymentMethod: false,
            isSameAsServiceAddress: false,
            address1: "",
            city: null,
            zipCode: null,
            state: "State",
            isTermsAndCondition: false,
          }
    );
  };

  const onSameAsServiceAddress = (event: any) => {
    if (event?.target?.checked) {
      const serviceAdd = user?.addresses?.find(
        (addr: any) => addr?.addressType === "ServiceAddress"
      );
      if (
        serviceAdd?.street &&
        serviceAdd?.city &&
        serviceAdd?.state &&
        serviceAdd?.zip
      ) {
        const serviceAddrState = StateList?.find(
          (state: any) =>
            state?.abbreviation === serviceAdd?.state ||
            state?.name === serviceAdd?.state
        );
        setValue("address1", serviceAdd?.street);
        setValue("city", serviceAdd?.city);
        setValue("state", serviceAddrState?.abbreviation || "");
        setValue("zipCode", serviceAdd?.zip);
        trigger("address1");
        trigger("city");
        trigger("state");
        trigger("zipCode");
      }
    } else {
      /* setValue("address1", card?.address1 || "");
      setValue("city", card?.city || null);
      setValue("state", card?.state || "State");
      setValue("zipCode", card?.zipCode || null); */
      setValue("address1", "");
      setValue("city", null);
      setValue("state", "State");
      setValue("zipCode", null);
      trigger("address1");
      trigger("city");
      trigger("state");
      trigger("zipCode");
    }
    setValue("isSameAsServiceAddress", event?.target?.checked);
  };

  const getAddressSuggetionsList = async (value: string) => {
    try {
      if (value) {
        const addressSuggetionsRes = await AMS_Lookup(
          {
            [ApiUrls?.amsLookUpURL]: `lookup?address=${value}`,
          },
          {
            Authorization: `Bearer ${amsToken?.id}`,
          }
        );
        if (
          addressSuggetionsRes?.status === 200 &&
          addressSuggetionsRes?.data?.responseData?.addresses?.length
        ) {
          setSuggetionsAddress(
            addressSuggetionsRes?.data?.responseData?.addresses
          );
        }
      } else {
        setSuggetionsAddress([]);
      }
    } catch (error) {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "street get address",
        error,
        undefined,
        sessionId,
        user.billingAccountNumber,
        userCompanyName,
        true
      );
      console.error(error);
    }
  };

  const onAddressChange = useCallback(debounce(getAddressSuggetionsList), [
    amsToken,
  ]);

  const onSelectAddress = (slectedAddress: any) => {
    const selectedAddrState = StateList?.find(
      (state: any) => state?.abbreviation === slectedAddress?.state
    );
    setValue("city", slectedAddress?.city);
    setValue(
      "state",
      selectedAddrState?.abbreviation || slectedAddress?.state || ""
    );
    setValue("zipCode", slectedAddress?.zipcode);
    trigger(["address1","city","state","zipCode"]);
  };

  const handleChange = (evt: any) => {
    const name = evt.target.name;
    const value = evt.target.value;
    let flag = false;

    if (name === "creditCardNumber") {
      set_CC_DC_Name("");
      const cardNo = value.replace(/ /g, "").trim();
      if (cardNo === "") {
        setCardImage(false);
      } else if (
        cardNo &&
        cardNo?.length &&
        validateCreditCardNumberAllowed(cardNo)
      ) {
        set_CC_DC_Name(getCardTypeByCardNumber(cardNo?.replaceAll(" ", "")));
        /*  setCardError("") */
      } else if (!validateCreditCardNumberAllowed(cardNo)) {
        /* setCardError("Please enter a valid Credit / Debit card number. Make sure it starts with 4, 5, or 6."); */
      }
    }
  };

  useEffect(() => {
    setCardImage(CC_DC_Name);
  }, [watch("creditCardNumber"), CC_DC_Name, card]);

  const cardDisplayFormat = (cardString: string) =>
    cardString
      .replace(/\W/gi, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();

  const getCursorStartPosition = (
    T: EventTarget & (HTMLInputElement | HTMLTextAreaElement)
  ) =>
    T.selectionStart && !(T.selectionStart % 5)
      ? ++T.selectionStart
      : T.selectionStart;


  return (
    <Box 
    className={`addNewPaymentMethod ${unAuthQbp ? "unauth-qbp" : "autopayAddCard"}`}>
      <form action="">
        {!unAuthQbp && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            id="scroll-dialog-title"
          >
            <Typography component="h2"
              className="prePayTitle"
              id="clear"
            >
              {fromEditCard
                ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.title
                : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.title }
            </Typography>
            {(watch("selectedCard") !== "Paypal") && <Typography  aria-describedby="clear"
              className="clearfield modelButton"
              sx={{
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={(e:any) => {
                e.preventDefault();
                clearForm();
              }}
              component="button"
            >
              <u>{PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.clearAllLabel}</u>
            </Typography>}
          </Box>
        )}

        {!unAuthQbp && (
          <Divider sx={{ border: "1px solid #000", marginTop: "16px" }} role="presentation"/>
        )}

        <Box
        //  id="scroll-dialog-description" 
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            my: 2,
            /*  mx: fromEditCard ? { sm: 0, md: 11 } : { sm: 0, md: 3 }, */
            mx: { sm: 0, md: 5 },
          }}
          className={`mainFields ${unAuthQbp ? 'unAuthfield' : ''}`}

        >
          {isPrePay && (
            <Typography
              className="paymentMethodLabel"
              component="label"
              id="selectedCard-com"  
              htmlFor="selectedCard"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                mt: 2,
                paddingBottom: "16px",
              }}
            >
              {
                QBP_FLOW?.select_payment_method_label
              }
            </Typography>
          )}

          {isPrePay && (
            <FormControl
              className="paymentMethodOptions"
              variant="standard"
              sx={{ width: "100%", my: 1 }}
            >
              <BootstrapSelect
                className="fs-mask"
                labelId="selectedCard-com"                
                id="selectedCard"
                aria-controls="selectedCard"
                {...register("selectedCard")}
                label="Credit/Debit card"
                defaultValue={"Credit Card"}
                readOnly={fromEditCard}
                disabled={fromEditCard}
                aria-describedby="selectedCard-com"
              >
                <MenuItem value="Credit Card" className="fs-mask">
                  {
                    QBP_FLOW?.Payment_methods_dropdown?.credit_debitcardLabel
                  }
                </MenuItem>
                <MenuItem value="Paypal" className="fs-mask">{"PayPal"}</MenuItem>
              </BootstrapSelect>
            </FormControl>
          )}

          {watch("selectedCard") === "Credit Card" && (
            <>
              <Typography component="h3"
                className="creditCardLabel font-primary text-color-primary"
                id="scroll-dialog-title"
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  mt: 2,
                }}
              >
                {
                  PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardInfoLabel
                }
              </Typography>

              <FormControl
                className="fullNameInput"
                variant="standard"
                sx={{ width: "100%", my: 1 }}
              >
                <InputLabel sx={inputLabelCss} shrink htmlFor="fullName">
                  {
                    PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardHolderNameLabel
                  }
                </InputLabel>

                <BootstrapInput
                  defaultValue=""
                  aria-describedby="full-name-error"
                  inputProps={{
                    "aria-invalid":
                      errors && Object.keys(errors)?.includes("fullName") ? "true" : "false",
                    "aria-required": true,
                  }}
                  id="fullName"
                  {...register("fullName")}
                  placeholder="Enter the name on your card"
                  readOnly={fromEditCard && card?.fullName?.trim() ? true : false}
                  disabled={fromEditCard && card?.fullName?.trim() ? true : false}
                  autoComplete="new-password"
                  className={
                    Object.keys(errors).length !== 0 &&
                    Object.keys(errors)?.includes("fullName")
                      ? "showErrorBorder_new fs-mask"
                      : "fs-mask"
                  }
                  onKeyPress={(e: any) => {
                    if (!/[A-Za-z ]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />

                <ErrorMessage
                  errors={errors}
                  name="fullName"
                  render={({ message }) => (
                    <Box className="errorMsgFormat" id="full-name-error" >
                      <span className="inputFiledErrorImg"></span>
                      <span className="inputFiledErrorMsg">{message}</span>
                    </Box>
                  )}
                />
              </FormControl>

              <FormControl
                className="creditCardInput"
                variant="standard"
                sx={{ width: "100%", my: 1 }}
              >
                <InputLabel
                  sx={inputLabelCss}
                  shrink
                  htmlFor="creditCardNumber"
                >
                  {PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardNumberLabel}
                </InputLabel>

                <BootstrapInput
                  defaultValue=""
                  id="creditCardNumber"
                  aria-describedby="cardtype credit-card-error"  
                  {...register("creditCardNumber")}
                  placeholder={PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cardNumberPlaceholder}
                  type={showCreditCardnum ? "text" : "password"}
                  autoComplete="new-password"
                  className={
                    Object.keys(errors).length !== 0 &&
                    Object.keys(errors)?.includes("creditCardNumber")
                      ? "showErrorBorder_new fs-mask"
                      : "fs-mask"
                  }
                  endAdornment={
                    <InputAdornment
                      position="end"
                      className="eyeToggleBtnWrap"
                      sx={{
                        padding: "0px",
                        position: "absolute",
                      }}
                    >
                      <IconButton
                        className="togglePwdVisiblebtn"
                        aria-label="card number"
                        aria-describedby="eye-toggle-new"
                        aria-pressed={showCreditCardnum}
                        onClick={() => setShowCreditCardnum(!showCreditCardnum)}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            setShowCreditCardnum(!showCreditCardnum)
                          }
                        }}
                        edge="end"
                        onMouseDown={handleMouseDownPassword}
                      >
                        {/* {!showCreditCardnum ? (
                          <img
                            src={VisibilityOffIcon}
                            alt="VisibilityOffIcon"
                          />
                        ) : (
                          <img src={VisibilityIcon} alt="VisibilityIcon" />
                        )} */}

                      <span aria-label={showCreditCardnum ? "show card number" : "hide card number"} id="eye-toggle-new">
                        <img src={showCreditCardnum ? VisibilityIcon : VisibilityOffIcon} alt="" />
                      </span>
                      </IconButton>
                    </InputAdornment>
                  }
                  onKeyPress={(event: any) => {
                    const T = event.target;

                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    } 
                    if (T.value.length < "19") {
                      const cursorStart = getCursorStartPosition(T);

                      T.value = cardDisplayFormat(T.value);
                      T.setSelectionRange(cursorStart, cursorStart);
                    }  else if(T.value.length===19){
                      //return true;
                    }  else {
                      event.preventDefault();
                      return false;
                    }
                  }}
                  // inputProps={{ maxLength: 19 }}
                  inputProps={{ maxLength: 19,
                    "aria-invalid":
                    errors && Object.keys(errors)?.includes("creditCardNumber") ? "true" : "false",
                  "aria-required": true }}
                  readOnly={fromEditCard}
                  onChange={(event) => {
                    const T: EventTarget &
                      (HTMLInputElement | HTMLTextAreaElement) = event.target;
                    const cursorStart = getCursorStartPosition(T);

                    handleChange(event);
                    T.value = cardDisplayFormat(T.value);
                    T.setSelectionRange(cursorStart, cursorStart);
                  }}
                  disabled={fromEditCard}
                />

                <ErrorMessage
                  errors={errors}
                  name="creditCardNumber"
                  render={({ message }) => (
                    <Box className="errorMsgFormat" id="credit-card-error"  >
                      <span className="inputFiledErrorImg"></span>
                      <span className="inputFiledErrorMsg">{message}</span>
                    </Box>
                  )}
                />
              </FormControl>

              <Box className="creditCardInput creditCardImages" id="cardtype">
                <img
                  className="singleCardImage"
                  alt="mastercard"
                  aria-label="master card selected"
                  aria-hidden=
                {
                  (cardImage && cardImage === "MasterCard") ||
                    (card?.creditCardType &&
                      card?.creditCardType.toUpperCase() === "MASTERCARD")
                      ? false
                      : true
                }          
                  src={
                    (cardImage && cardImage === "MasterCard") ||
                    (card?.creditCardType &&
                      card?.creditCardType.toUpperCase() === "MASTERCARD")
                      ? mastercard
                      : mastercarddisabled
                  }
                ></img>
                <img
                  className="singleCardImage"
                  alt="visacard"
                  aria-label="visa card selected"  
                  aria-hidden=
                  {
                    (cardImage && cardImage === "Visa") ||
                      (card?.creditCardType &&
                        card?.creditCardType.toUpperCase() === "VISA")
                      ? false
                      : true
                  }   
                  src={
                    (cardImage && cardImage === "Visa") ||
                    (card?.creditCardType &&
                      card?.creditCardType.toUpperCase() === "VISA")
                      ? visacard
                      : visacarddisabled
                  }
                ></img>
                <img
                  className="singleCardImage"
                  alt="discovercard"
                  aria-label="discover card selected"
                  aria-hidden=                 {
                    (cardImage && cardImage === "Discover") ||
                    (card?.creditCardType &&
                      card?.creditCardType.toUpperCase() === "DISCOVER")
                      ? false
                      : true
                  }
                  src={
                    (cardImage && cardImage === "Discover") ||
                    (card?.creditCardType &&
                      card?.creditCardType.toUpperCase() === "DISCOVER")
                      ? discovercard
                      : discovercarddisabled
                  }
                ></img>
              </Box>

              <Box
                className="creditCardInput expireCvvDate"
                sx={{
                  display: { xs: "block", md: "flex", sm: "flex" },
                  width: "100%",
                }}
              >
                <FormControl
                  className="expirationDateInput"
                  variant="standard"
                  sx={{ my: 1 }}
                >
                  <InputLabel
                    sx={inputLabelCss}
                    shrink
                    htmlFor="expirationDate"
                  >
                    {PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.expDateLabel}*
                  </InputLabel>
                  <BootstrapInput
                    // inputProps={{ maxLength: 7, minLength: 7 }}
                    defaultValue=""
                    aria-describedby="expiration-date-error date-txt"
                    inputProps={{
                      "aria-invalid":
                        errors && Object.keys(errors)?.includes("expirationDate") ? "true" : "false",
                      "aria-required": true,
                      maxLength: 7, minLength: 7
                    }}
                    id="expirationDate"
                    autoComplete="new-password"
                    className={
                      Object.keys(errors).length !== 0 &&
                      Object.keys(errors)?.includes("expirationDate")
                        ? "showErrorBorder_new fs-mask"
                        : "fs-mask"
                    }
                    {...register("expirationDate")}
                    placeholder={PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.expDatePlaceholder}
                    onKeyDown={(e: any) => {
                      return creditCardExpiryAutoFormat(e);
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="expirationDate"
                    render={({ message }) => (
                      <Box className="errorMsgFormat" id="expiration-date-error" >
                        <span className="inputFiledErrorImg"></span>
                        <span className="inputFiledErrorMsg">{message}</span>
                      </Box>
                    )}
                  />
                </FormControl>
                <FormControl
                  className="cvvInput"
                  variant="standard"
                  sx={{ my: 1 }}
                >
                  <InputLabel sx={inputLabelCss} shrink htmlFor="cvv">
                    {PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cvvLabel}*
                  </InputLabel>
                  <BootstrapInput
                    id="cvv"
                    aria-describedby="cvv-error cvv-txt"
                    autoComplete="new-password"
                    className={
                      Object.keys(errors).length !== 0 &&
                      Object.keys(errors)?.includes("cvv")
                        ? "showErrorBorder_new fs-mask"
                        : "fs-mask"
                    }
                    type={showPass ? "text" : "password"}
                    {...register("cvv")}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        className="eyeToggleBtnWrap"
                        sx={{
                          padding: "0px",
                          position: "relative",
                        }}
                      >
                        <IconButton
                          className="togglePwdVisiblebtn"
                          aria-label="cvv code"
                          aria-describedby="eye-toggle"
                          aria-pressed={showPass}                         
                          onClick={() => setShowPass(!showPass)}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              event.preventDefault();
                              setShowPass(!showPass)
                            }
                          }}
                          edge="end"
                          onMouseDown={handleMouseDownPassword}
                        >
                          {/* {!showPass ? (
                            <img
                              src={VisibilityOffIcon}
                              alt="VisibilityOffIcon"
                            />
                          ) : (
                            <img src={VisibilityIcon} alt="VisibilityIcon" />
                          )} */}
                          {!showPass ? (
                            <span aria-label="hide CVV code" id="eye-toggle"><img src={VisibilityOffIcon} alt="" /></span>
                          ) : (
                            <span aria-label="show CVV code" id="eye-toggle"> <img src={VisibilityIcon} alt="" /></span>
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    defaultValue=""
                    // inputProps={{ maxLength: 3, minLength: 3 }}
                    inputProps={{
                      "aria-invalid":
                        errors && Object.keys(errors)?.includes("cvv") ? "true" : "false",
                      "aria-required": true,
                      maxLength: 3, minLength: 3
                    }}  
                    placeholder={
                      unAuthQbp ? '3-digit code' : 'Enter 3-digit code'
                    }
                    onKeyPress={(e: any) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="cvv"
                    render={({ message }) => (
                      <Box className="errorMsgFormat" id="cvv-error" >
                        <span className="inputFiledErrorImg"></span>
                        <span className="inputFiledErrorMsg">{message}</span>
                      </Box>
                    )}
                  />
                </FormControl>
              </Box>

              {/*** Hide this checkbox for Unauth qbp */
               !unAuthQbp && <Typography
                component="span"
                className="checkBox primarycheckboxService"
              >
                <label className="checkboxMain sameAddress"  htmlFor="sameadrs">
                  <input
                    type="checkbox"
                    id="sameadrs"
                    checked={watch("isSameAsServiceAddress")}
                    aria-checked={watch("isSameAsServiceAddress")}
                    onChange={onSameAsServiceAddress}
                    className="radioInput"
                  />
                  {fromEditCard
                    ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.sameAsServiceAddCheckboxLabel
                    : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.sameAsServiceAddCheckboxLabel}
                  <span className="checkBoxLabel"></span>
                </label>
              </Typography>}

              {/* Address Start Here */}
              <FormControl variant="standard" className="addressOne">
                <InputLabel shrink id="address1" htmlFor="address1">
                  {PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderStreetAddressLabel}
                </InputLabel>

                <BootstrapAutocomplete
                  freeSolo
                  // readOnly={!!watch("isSameAsServiceAddress")}
                  className={
                    Object.keys(errors).length !== 0 &&
                    Object.keys(errors)?.includes("address1")
                      ? "showErrorBorder_new"
                      : ""
                  }                
                  aria-describedby = "addressOne-error"                 
                  id="address1"
                  ref = {addressOneRef} 
                  onKeyPress={(e: any) => {
                    if (!/[A-Za-z0-9 ]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if(!e.target.value && e.key===' ') {//Prevents First space charac
                      e.preventDefault();
                    }
                  }}
                  onChange={(_, slectedAddress: any) => {
                    onSelectAddress(slectedAddress);
                  }}
                  onInputChange={(_, value) => {
                    setValue("address1", value.trimStart());
                    onAddressChange(value);
                    trigger("address1");
                  }}
                  
                  onBlur={() => trigger("address1")}
                  inputValue={watch("address1")}
                  disableClearable
                  options={suggetionsAddresses}
                  getOptionLabel={(option: any) => option?.street_line || ""}
                  renderOption={(props, option: any) => {
                    return (
                      <li
                        {...props}
                        key={
                          option?.street_line +
                          option?.secondary +
                          option?.city +
                          option?.zipcode +
                          option?.source
                        }
                      >
                        {option?.street_line} {option?.secondary} {option?.city}{" "}
                        {option?.zipcode}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                    required
                      {...params}                      
                      placeholder={PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderStreetAddressPlaceholder}
                      inputProps={{
                        ...params.inputProps,  
                        'aria-describedby':"addressOne-error"                     
                      }}
                    />
                  )}
                 
                />
                <ErrorMessage
                  errors={errors}
                  name="address1"
                  render={({ message }) => (
                    <Box className="errorMsgFormat"  id="addressOne-error">
                      <span className="inputFiledErrorImg"></span>
                      <span className="inputFiledErrorMsg">{message}</span>
                    </Box>
                  )}
                />
              </FormControl>

              <Box
                sx={{ display: { xs: "block", md: "flex" } }}
                className="cityZipcode"
              >
                <FormControl
                  className={unAuthQbp ? 'cityInput-unAuthQbp' : "cityInput"}
                  variant="standard"
                  sx={{ width: "100%", my: 1 }}
                >
                  <InputLabel sx={inputLabelCss} shrink htmlFor="city">
                    {fromEditCard
                      ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cityLabel
                      : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cityLabel}
                    *
                  </InputLabel>
                  <BootstrapInput
                    defaultValue=""
                    id="city"
                    aria-describedby="city-error"
                    className={
                      Object.keys(errors).length !== 0 &&
                      Object.keys(errors)?.includes("city")
                        ? "showErrorBorder_new fs-mask"
                        : "fs-mask"
                    }
                    {...register("city")}
                    placeholder={PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderCityPlaceholder}
                    onKeyPress={(e: any) => {
                      if (!/[A-Za-z0-9 ]/.test(e.key)) {
                        e.preventDefault();
                      }
                      if(!e.target.value && e.key===' ') {//Prevents First space charac
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      setValue("city", e.target.value.trimStart());
                    }}
                    inputProps={{
                      "aria-invalid":
                        errors && Object.keys(errors)?.includes("city") ? "true" : "false",
                      "aria-required": true,                     
                    }}    
                  />
                  <ErrorMessage
                    errors={errors}
                    name="city"
                    render={({ message }) => (
                      <Box className="errorMsgFormat"  id="city-error">
                        <span className="inputFiledErrorImg"></span>
                        <span className="inputFiledErrorMsg">{message}</span>
                      </Box>
                    )}
                  />
                </FormControl>
                <span id="requiredstart" style={{opacity:"0", position:"absolute", left:"0"}}>
                 required
                </span>
                <Box className={unAuthQbp ? 'stateZipCode-unAuthQbp' : "stateZipCode"}>
                  <FormControl
                    className="stateInput"
                    variant="standard"
                    sx={{ width: "50%", my: 1, mx: 2 }}
                  >
                    <InputLabel
                      id="state"
                      sx={inputLabelCss}
                      shrink
                      htmlFor="state-com"
                    >
                      {fromEditCard
                        ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.stateLabel
                        : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.stateLabel}
                      *
                    </InputLabel>
                    <BootstrapSelect
                      // labelId="state"                      
                      aria-describedby={errors?.state ? "state-error" : undefined}
                      aria-controls="state-com"  
                      aria-invalid= {errors && Object.keys(errors)?.includes("state") ? true : false}
                      id="state"
                      {...register("state")}
                      value={watch("state")}
                      ref={autocompleteStateRef}
                      onChange={(event: any) =>
                        setValue("state", event?.target?.value)
                      }
                      defaultValue={card?.state || ""}
                      // readOnly={!!watch("isSameAsServiceAddress")}
                      className={
                        Object.keys(errors).length !== 0 &&
                        Object.keys(errors)?.includes("state")
                          ? "statePlaceholder showErrorBorder_new"
                          : watch("state") === "State"
                          ? "statePlaceholder fs-mask"
                          : "fs-mask"
                      }
                      inputProps={{
                        "aria-invalid":
                          errors && Object.keys(errors)?.includes("state") ? true : false,
                        "aria-required": true,   
                         'aria-describedby':"state-error"                                                        
                      }}
                    >
                      {StateList?.map((item) => {
                        const isSelected = item?.abbreviation === watch("state");
                        return (
                          <MenuItem
                            key={item?.abbreviation}
                            value={item?.abbreviation}
                            className="fs-mask"
                            sx={{
                              '&.Mui-selected': {
                                backgroundColor: '#d0e9ec !important', // highlight selected item
                              },
                              '&:focus': {
                                backgroundColor: '#b2ebf2', // highlight on focus
                              },
                            }} autoFocus={isSelected}
                          >
                            {item?.abbreviation}
                          </MenuItem>
                        );
                      })}
                    </BootstrapSelect>
                    <ErrorMessage
                      errors={errors}
                      name="state"
                      render={({ message }) => (
                        <Box className="errorMsgFormat"  id="state-error">
                          <span className="inputFiledErrorImg"></span>
                          <span className="inputFiledErrorMsg">{message}</span>
                        </Box>
                      )}
                    />
                  </FormControl>

                  <FormControl
                    className="zipCodeInput"
                    variant="standard"
                    sx={{ width: "50%", my: 1 }}
                  >
                    <InputLabel sx={inputLabelCss} shrink htmlFor="zipCode">
                      {
                      // PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderZipCodeLabel
                          "ZIP code*"
                      }
                    </InputLabel>
                    <BootstrapInput
                      defaultValue=""
                      id="zipCode"
                      aria-describedby="zipcode-error"                     
                      className={
                        Object.keys(errors).length !== 0 &&
                        Object.keys(errors)?.includes("zipCode")
                          ? "showErrorBorder_new fs-mask"
                          : "fs-mask"
                      }
                      {...register("zipCode")}
                      placeholder={PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cardholderZipCodePlaceholder}
                      // readOnly={!!watch("isSameAsServiceAddress")}
                      inputProps={{
                        "aria-invalid":
                          errors && Object.keys(errors)?.includes("zipCode") ? "true" : "false",
                        "aria-required": true,
                        maxLength: 5, minLength: 5
                      }}
                      onKeyPress={(e: any) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="zipCode"
                      render={({ message }) => (
                        <Box className="errorMsgFormat"  id="zipcode-error">
                          <span className="inputFiledErrorImg" ></span>
                          <span className="inputFiledErrorMsg">{message}</span>
                        </Box>
                      )}
                    />
                  </FormControl>
                </Box>
              </Box>

              {(isAutoPay || isPrePay) && ( /**Only for Autopay */
                <Typography
                  component="span"
                  className="checkBox primarycheckbox"
                >
                  <label className="checkboxMain makePrimaryPaymentCheckbox">
                    <input
                      type="checkbox"
                      checked={watch("isPrimaryPaymentMethod")}
                      aria-checked={watch("isPrimaryPaymentMethod")}
                      onChange={(event) =>
                        setValue("isPrimaryPaymentMethod", event.target.checked)
                      }
                      readOnly={!defaultPaymentMethodId || defaultPaymentMethodId === card?.cardId}
                      disabled={!defaultPaymentMethodId || defaultPaymentMethodId === card?.cardId}
                      className="radioInput"
                    />
                    {QBP_ON
                      ? `${PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.saveCardForFurthurUse}`
                      : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.makePrimaryMethodCheckboxLabel}
                    <span className="checkBoxLabel"></span>
                  </label>
                </Typography>
              )}
            </>
          )}

        {watch("selectedCard") === "Paypal" && (
          <>
            <Box sx={{width:'380px'}} className="paypalDesc">
              <Box>
                <img src={payPalIcon} alt="payPalIcon" />
              </Box>
              <Typography className="title">
                {PAY_PAL_DETAILS?.title}
              </Typography>
              <Typography className="desc fs-mask">
                {PAY_PAL_DETAILS?.details}
              </Typography>

              <Typography component="span" className="checkBox">
                <label className="checkboxMain" htmlFor="priMethod">
                  <input
                    id="priMethod"
                    type="checkbox"
                    onChange={(event) => {
                      window?.localStorage?.setItem(
                        "paypal_IsPrimaryPaymentMethod",
                        JSON?.stringify(event.target.checked)
                      );
                    }}
                    readOnly={card?.cardId === defaultPaymentMethodId}
                    className="radioInput"
                  />
                  {PAY_PAL_DETAILS?.makePrimaryMethodCheckboxLabel}
                  <span className="checkBoxLabel"></span>
                </label>
              </Typography>
            </Box>
          </>
        )}

        </Box>

        {/* {(!QBP_ON || isAutoPay) && ( */}

        
        {watch("selectedCard") !== "Paypal" && (showTC) && (
          <Box>
            <Typography component="span" className="before-continuing" id="agreementTerms">
            
            {
             ["CTL", "CENTURY LINK"].includes(companyName.toUpperCase()) 
             ? QBP_FLOW?.payment_descriptions?.terms_and_conditions
             :"Before continuing, please review the Terms and Conditions of our payment processor (ACI Speedpay) and, if acceptable, check the box below."
            }
            </Typography>

            <FormControl variant="standard">
              <Typography component="div" className="checkBox termsCheckbox">
                <label className="checkboxMain">
                  <input
                    type="checkbox"
                    /*  checked={termsAndConditions}
                    onChange={()=>{settermsAndConditions(!termsAndConditions)}} */
                    className="radioInput" 
                    id="isTermsAndCondition"
                    checked={watch("isTermsAndCondition")}
                    aria-checked={watch("isTermsAndCondition")}
                    aria-required="true"               
                    aria-describedby="terms agreementTerms"
                    onChange={(event) => (
                      setValue("isTermsAndCondition", event.target.checked),
                      trigger("isTermsAndCondition")
                    )}
                    ref={checkboxRef}
                  />
                  <Typography component="span">{PAYMENT_METHOD_CREDIT_MANAGE_AUTOPAY_SECTION?.terms_condi_agree}</Typography>
                  <Typography
                    component="a"
                    aria-label={QBP_FLOW?.payment_descriptions?.termsconditionsLabel + " opens in new tab"}
                    href={ 
                      (companyName &&
                      ["CTL", "CENTURY LINK"].includes(companyName.toUpperCase())) ||
                      (user?.billingType && 
                      (user?.billingType?.toUpperCase() === "POSTPAID"))
                        ? "https://www.speedpay.com/terms/" 
                        : "https://www.brightspeed.com/aboutus/legal/consumer/payment-agreement"

                    }
                    
                    target="_blank"

                    
                  >
                    {QBP_FLOW?.payment_descriptions?.termsconditionsLabel}
                  </Typography>.*                 
                  <span
                    className={
                      Object.keys(errors).length !== 0 &&
                      Object.keys(errors)?.includes("isTermsAndCondition")
                        ? "showErrorBorder_new checkBoxLabel"
                        : "checkBoxLabel"
                    }
                  ></span>
                </label>
              </Typography>

              <ErrorMessage
                errors={errors}
                name="isTermsAndCondition"
                render={({ message }) => (
                  <Box className="errorMsgFormat"   id="terms">
                    <span className="inputFiledErrorImg"></span>
                    <span className="inputFiledErrorMsg">{message}</span>
                  </Box>
                )}
              />
            </FormControl>
          </Box>
        )}

        {watch("selectedCard") !== "Paypal" && <Box className="required-lbl" id="required">
          <Typography component="span">
            {QBP_CONTENT_2?.qbp_flow?.required_label}
          </Typography>{" "}
        </Box>}

        

          
            <Box className="payment-overlay-cta">
              <Button
                variant="outlined"
                color="primary"                
                onClick={() => {
                  addEneventGTM(
                    fromEditCard
                      ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cancelButtonLabel
                      : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cancelButtonLabel,
                    sessionId,
                    user.billingAccountNumber,
                    userCompanyName
                  );
                  unAuthQbp 
                  ? DwLogutil({
                      ...dwLogDefaults,
                      stepName: unauthqbp_cancel_step1
                    })
                  :(isAutoPay)?DwLogutil({
                    ...dwLogDefaults,
                    stepName: (fromEditCard)?AP_edit_PM_CD_card_cancel_cta :AP_add_PM_CD_card_cancel_cta
                  }) :(isPrePay)?DwLogutil({
                    ...dwLogDefaults,
                    stepName:(fromEditCard) ? EC_DW_LOGGING_STEPS?.pre_edit_popup_CD_PM_cancle_cta : EC_DW_LOGGING_STEPS?.pre_add_popup_CD_PM_cancle_cta
                  }) :               
                   DwLogutil({
                      ...dwLogDefaults,
                      stepName: qbp_cancel_form
                    });
                  onClose();
                  dispatch(setShowEditPaymentPopUp(false));
                }}
              >
                {fromEditCard
                  ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cancelButtonLabel
                  : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cancelButtonLabel}
              </Button>

              {(watch("selectedCard") !== "Paypal")?<Button
                variant="contained"
                color="primary"              
                form="zuora-post"
                type="submit"
                onClick={handleSubmit(onSubmit)}
                disabled={ !isAutoPay && (isEditFormTidy || isUnAUthQbpFormTidy  || isUnAuthPAFormTidy ) }
              >
                {unAuthQbp
                  ? "Agree and continue"
                  :"Continue" /* user?.billingType && user?.billingType === "postpaid"
                  ? "Continue"
                  : "Save" */}
              </Button>:<Button
                variant="contained"
                color="primary"              
                form="zuora-post"
                type="submit"
                onClick={() =>{ onPaypal()}}
                disabled={ !isAutoPay && (isEditFormTidy || isUnAUthQbpFormTidy  || isUnAuthPAFormTidy ) }
              >
                {PAY_PAL_DETAILS?.saveButtonLabel}
              </Button>}
            </Box>

            <Backdrop
              className="custom-loader-backdrop"
              sx={{
                color: "#fff",
                zIndex: (theme: any) => theme.zIndex.drawer + 2,
              }}
              open={isSubmitLoader}
            >
              <div className="custom-loader"></div>
            </Backdrop>
          
        
      <Box className="new-close-icon-cantainer">
            <Typography component="button" className="buttonText" aria-label="Close the dialog"
              onClick={(e: any) => {
                /*  addEneventGTM(
                            fromEditPayment
                                ? PAYMENT_METHOD_CREDIT_CARD_EDIT_SECTION?.cancelButtonLabel
                                : PAYMENT_METHOD_CREDIT_CARD__ADD_SECTION?.cancelButtonLabel,
                            sessionId,
                            user.billingAccountNumber
                        ); */
                e.preventDefault();
                onClose();
                const stepName=unAuthQbp ? qbp_cancel_form : isUnAuthPa ? EC_DW_LOGGING_STEPS.Pa_cancel_form :(isAutoPay)?(fromEditCard)?AP_edit_PM_CD_card_cancel_cta :AP_add_PM_CD_card_cancel_cta:(isPrePay) ?(fromEditCard) ? EC_DW_LOGGING_STEPS?.pre_edit_popup_CD_PM_cancle_cta : EC_DW_LOGGING_STEPS?.pre_add_popup_CD_PM_cancle_cta : ""
                DwLogutil({
                  ...dwLogDefaults,
                  stepName
                });
                addEneventGTM(
                  stepName,
                  sessionId,
                  user?.billingAccountNumber,
                  companyName
                ); 
                dispatch(setShowEditPaymentPopUp(false));
              }}>
              <img
                src={close}
                alt="Close the dialog"
              />
            </Typography>
          </Box>
      </form>
    </Box>
  );
};

export default AddPaymentMethodNew;
